export const inputNames = [
	{
		name: "Your name",
		id: "name",
		required: true,
		type: "text",
		// message: "Must be longer then 3 characters",
	},
	{
		name: "Company name",
		id: "companyName",
		required: true,
		type: "text",
		// message: "Will be used for carbon certificates",
	},
	{
		name: "Email",
		id: "email",
		required: true,
		type: "email",
		message: "",
	},
	{
		name: "Password",
		id: "password",
		required: true,
		type: "password",
		message: "Must be longer then 6 characters",
	},
];
